import { FormField, SearchField } from '@/components/custom/erp';
import { BoPhan } from '@/types/schemas/bo-phan.type';
import { QUERY_KEYS } from '@/constants/query-keys';
import { boPhanSearchColumns } from '@/constants';
import { Label } from '@/components/ui/label';

interface Props {
  formMode: 'add' | 'edit' | 'view';
  boPhan: BoPhan | null;
  setboPhan: (boPhan: BoPhan) => void;
}

export const OtherTab = ({ formMode, boPhan, setboPhan }: Props) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Mã phụ</Label>
        <FormField className='flex max-w-[320px] items-center gap-x-1' name='ma_vt2' disabled={formMode === 'view'} />
      </div>

      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Kiểu hoạch định</Label>
        <div className='w-[250px]'>
          <FormField
            className='flex max-w-[320px] items-center gap-x-1'
            name='kieu_hd'
            type='select'
            options={[
              { value: 0, label: '0. Không tính hoạch định' },
              { value: 1, label: '1. Hoạch định' },
              { value: 2, label: '2. Hoạch định theo cỡ lô' }
            ]}
            disabled={formMode === 'view'}
          />
        </div>
      </div>

      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Mã bộ phận</Label>
        <SearchField<BoPhan>
          displayRelatedField='ten_bp'
          columnDisplay='ma_bp'
          disabled={formMode === 'view'}
          searchEndpoint={`/${QUERY_KEYS.BO_PHAN}`}
          searchColumns={boPhanSearchColumns}
          dialogTitle='Danh mục bộ phận'
          value={boPhan?.ma_bp || ''}
          relatedFieldValue={boPhan?.ten_bp || ''}
          onRowSelection={setboPhan}
          className='w-100'
        />
      </div>

      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Tồn tối thiểu</Label>
        <FormField
          className='flex max-w-[320px] items-center gap-x-1'
          name='sl_min'
          type='number'
          disabled={formMode === 'view'}
        />
      </div>

      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Tồn tối đa</Label>
        <FormField
          className='flex max-w-[320px] items-center gap-x-1'
          name='sl_max'
          type='number'
          disabled={formMode === 'view'}
        />
      </div>

      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Ngày nhập cuối</Label>
        <FormField
          className='flex w-48 items-center gap-x-1'
          name='ngay_nhap'
          type='date'
          disabled={formMode === 'view'}
        />
      </div>

      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Ngày xuất cuối</Label>
        <FormField
          className='flex w-48 items-center gap-x-1'
          name='ngay_xuat'
          type='date'
          disabled={formMode === 'view'}
        />
      </div>

      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Ghi chú</Label>
        <div className='flex-1'>
          <FormField name='ghi_chu' disabled={formMode === 'view'} />
        </div>
      </div>

      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Trạng thái</Label>
        <div className='w-[250px]'>
          <FormField
            className='flex max-w-[320px] items-center gap-x-1'
            name='status'
            type='select'
            options={[
              { value: 0, label: '0. Không sử dụng' },
              { value: 1, label: '1. Còn sử dụng' },
              { value: 2, label: '2. Quy cách chi tiết' }
            ]}
            disabled={formMode === 'view'}
          />
        </div>
      </div>
    </div>
  );
};
